<template>
	<div>
    <div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="px-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
      <template v-else>
      	<simple-feedback-form
      		v-if="feedback_form.form_style === 'SIMPLE'"
      		:form="feedback_form"
      		:feedback_id="params.feedback_id"
      	/>
      	<template v-else>
      	<!-- RESERVATION DETAIL -->
	      <template v-if="reservation.id">
	      	<div class="p-4 pb-5" style="background-color:#fafafa">
	      		<p class="sub-heading-1-1 mb-3 text-semi-dark">Reservation Detail</p>
				    <div class="w-100">
							<div class="w-100 bg-white border-semi-grey radius-8 p-3">
								<div class="row no-gutters">
									<div class="col-2 align-self-center">
										<div class="w-100 pr-2">
											<div class="w-100 bg-orange text-center radius-8" style="padding:13px 0px;">
												<i class="simple-icon-home text-18 text-white"></i>
											</div>
										</div>
									</div>
									<div class="col-7 align-self-center">
										<div class="pr-2">
											<p class="mb-0 body-2-1">{{reservation.room_type.name}}</p>
											<div class="w-100 no-ws">
												<p class="mb-0 d-inline-block align-middle body-3-3-1 mr-2">Room : </p>
												<p class="mb-0 d-inline-block align-middle body-3-1">{{reservation.room.id ? reservation.room.name : '-'}}</p>
											</div>
											<p class="mb-0 body-3-1 text-info">Folio {{reservation.folio_number != '' ? `#${reservation.folio_number}` : '#'}}</p>
										</div>
									</div>
									<div class="col-3 align-self-center text-right">
										<p class="mb-0 body-3-3-1">Guest Name</p>
										<p class="mb-0 body-3-1">{{reservation.guest_profile.id ? reservation.guest_profile.name : '-'}}</p>
									</div>
									<div class="col-12 my-3">
										<div class="w-100 border-2-bottom-dashed"></div>
									</div>
									<div class="col-6">
										<p class="mb-0 body-3-3-1">Check in</p>
										<p class="mb-0 body-3-1">{{$formatDate(reservation.arrival_date,'YYYY-MM-DD')}}</p>
									</div>
									<div class="col-6">
										<p class="mb-0 body-3-3-1">Check out</p>
										<p class="mb-0 body-3-1">{{$formatDate(reservation.departure_date,'YYYY-MM-DD')}}</p>
									</div>
								</div>
							</div>
						</div>
	    		</div>
					<div class="border-bottom-6"></div>
	      </template>
				<div class="p-4 th-feedback" :class="{'mt-4':!reservation.id}">
	      	<div class="mb-4">
	      		<p class="sub-heading-1-1 mb-3 text-semi-dark" @click="test">{{feedback_form.title}}</p>
						<img v-if="feedback_form.image_url != null" :src="feedback_form.image_url" alt="merchant-feedback" class="w-100 radius-6">
						<div class="html-desc body-2-2 mt-2" v-html="feedback_form.description"></div>
	      	</div>

	      	<!-- QUESTION LIST -->
	      	<ol class="pl-4">
	      		<li class="mb-4 pb-3 w-100 pl-2 body-1-2" id="name" v-if="!reservation.id">
		      		<p class="mb-1 body-1-2">Your name <span class="text-danger font-">*</span></p>
		      		<input 
		          	class="form-control px-2 body-2 rounded-6 mb-2" 
		          	rows="2" 
		          	v-model="guest_name"
		          	> 
	          	<p class="body-3-3 text-danger w-100 mb-0" v-if="name_error != ''">{{name_error}}</p>
		      	</li>

		      	<li class="mb-4 pb-3 w-100 pl-2 body-1-2" v-for="(qst,index) in feedback_form.question_list" :key="index" :id="qst.id">
		      		<p class="mb-1 body-1-2">{{qst.question}} <span class="text-danger font-"  v-if="qst.is_required">*</span></p>

		      		<!-- TEXT -->
		      		<textarea 
		      			v-if="qst.answer_type == 'TEXT'"
		          	class="form-control px-2 body-2 rounded-6 text-14 mb-2" 
		          	rows="2" 
		          	v-model="feedback_form.question_list[index].answer"
		          	> 
		          </textarea>

		          <!-- MULTIPLE_CHOICE -->
		          <div class="row" v-if="qst.answer_type == 'MULTIPLE_CHOICE'">
		          	<div class="col-6" v-for="ans in qst.answer_list">
		          		<input type="checkbox" class="checkbox" :id="ans.id" :value="ans" v-model="feedback_form.question_list[index].answer">
									<label :for="ans.id" class="body-2-2">{{ans.value}}</label>		
		          	</div>
		          </div>

		          <!-- CHOICE -->
		          <div class="row" v-if="qst.answer_type == 'CHOICE'">
		          	<div class="col-6" v-for="ans in qst.answer_list">
				          <input type="radio" class="radio" :id="ans.id" :value="ans" v-model="feedback_form.question_list[index].answer"/>
									<label :for="ans.id" class="body-2-2">{{ans.value}}</label>
								</div>
							</div>

							<!-- STAR -->
							<div class="d-block text-center align-middle align-self-center" v-if="qst.answer_type == 'STAR'">
		            <star-rating 
		              class="mt-2 mx-auto d-block feedback"
		              :star-size="36"
		              active-color="#fbc632"
		              border-color="#e4e4e4" 
		              :increment="1"
		              :rating="0"
		              :read-only="false"
		              :show-rating="false"
		              :rounded-corners="true"
		              :border-width="1"
		              :padding="0"
		              v-model="feedback_form.question_list[index].answer">    
		            </star-rating>
		            <div class="row">
		            	<div class="col-6 text-left">
										<p class="mb-0 body-3-1 text-12 text-white-light">Very bad</p>
		            	</div>
		            	<div class="col-6 text-right"></div>
		            </div>
		          </div>

		          <p class="body-3-3 text-danger w-100 mb-0" v-if="qst.is_required && qst.error != ''">{{qst.error}}</p>
		      	</li>
		      </ol>
          
          <state-button :click="submitForm" variant="primary" block size="lg">{{$t('general.submit-feedback')}}</state-button>
				</div>
    	</template>
	      </template>


	   	<popup-detail
			id_ref="success_form"
    	direction="bottom" 
    	:show="show_result"
    	use_max_size
    	wrapper_size="mobile"
    	use_footer
    	no_close_backdrop
    	@close="toggleResult">
    	<template v-slot:body>
    		<div class="py-5 px-4 text-center">
    			<div class="rounded-100 my-2 w-20 mx-auto">
            <div class="bg-success rounded-100 mx-auto size-icon-in" v-if="result_message == 'success'">
              <img src="../../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
            </div>
            <div class="bg-danger rounded-100 mx-auto size-icon-in" v-if="result_message == 'fail'">
              <img src="../../../assets/img/icon/close-white.png" width="40" style="margin: 20px 20px">
            </div>
          </div>
	    		<p class="w-75 mt-4 mx-auto body-2-2">{{result_message == 'success' ? 'Thank you for filling out the form we have provided' : 'You have already filled out the form'}}</p>
	    	</div>
    	</template>
    	<template v-slot:footer>
	    	<div class="px-3 pt-3">
	    		<router-link :to="`/${getMerchant.code}`">
            <button 
							class="ga-btn-primary-lg" >
							Back to homepage
						</button>
          </router-link>
				</div>
	    </template>
    </popup-detail>
    </template>
  </div>
</template>
<script>
	import {mapGetters,mapMutations,mapActions} from "vuex";
	import {get,post} from '@/services/index.js';
	import SimpleFeedbackForm from './SimpleFeedbackForm';
	export default{
		components: { SimpleFeedbackForm },
		metaInfo(){
      return {
        title: 'FeedBack',
        titleTemplate: this.getMetaTitleTemplate
      }
    },
		data(){
			return{
				is_load: true,
				error: '',
				reservation: {},
				feedback_form: {},
				show_result: false,
				result_message: '',
				guest_name: '',
				name_error: ''
			}
		},
		computed:{
			...mapGetters(['getMerchant']),
			params(){
				let return_data = {
					feedback_id: this.$route.params.feedback_id ? this.$route.params.feedback_id : '',
					reservation_id: this.$route.query.reservation_id ? this.$route.query.reservation_id : ''
				}
				return return_data
			}
		},
		mounted(){
			this.loadFirstData()
		},
		methods:{
			test(){
				console.log("this.feedback_form :", this.feedback_form)
				this.toggleSuccessMessage()
			},
			loadFeedbackForm(){
				return new Promise((success,fail)=>{
					get("CORE_HOTEL",`feedback-form/${this.params.feedback_id}`,{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						if(response.data.success){
							this.feedback_form = response.data.data
							this.feedback_form.question_list = this.feedback_form.question_list.map(x=>{
								let return_data = {
									...x,
									answer: null,
									error: ''
								}
								if(x.answer_type == 'TEXT'){
									return_data.answer = ''
								}else if(x.answer_type == 'STAR'){
									return_data.answer = 0
								}else if(x.answer_type == 'CHOICE'){
									return_data.answer = {}
								}else if(x.answer_type == 'MULTIPLE_CHOICE'){
									return_data.answer = []
								}
								return return_data
							})
							success()
						}else{
							fail(response.data.message)
						}
					})
				})
			},
			loadReservationDetail(){
				return new Promise((success,fail)=>{
					get("CONCIERGE",`reservation/${this.params.reservation_id}`,{
						merchant_id: this.getMerchant.id
					}).then(response=>{
						if(response.data.success){
							this.reservation = response.data.data
							let allowed_status = ['PRE_CHECKIN','CHECKIN','CHECKOUT']
							let status_valid = allowed_status.some(x=>x==response.data.data.status)
							if(status_valid){
								success()
							}else{
								fail("Invalid Reservation. Please contact the staff for further information")
							}
						}else{
							fail(response.data.message)
						}
					})
				})
			},
			loadFirstData(){
				this.is_load = true
				if(this.params.feedback_id == ''){
					this.error = 'Feedback form not found'
					this.is_load = false
				}else{
					this.error = ''
					let func_exc = []
					if(this.params.reservation_id != ''){	
						func_exc.push(this.loadReservationDetail())
					}
					func_exc.push(this.loadFeedbackForm())
					Promise.all(func_exc).catch(err=>{
						this.error = err
					}).finally(()=>this.is_load = false)
				}
			},
			toggleResult(message){
				this.result_message = message 
				this.show_result = !this.show_result
			},
			validateForm(){
				return new Promise((success,fail)=>{
					let first_error = ''
					if(!this.reservation.id && this.guest_name == ''){
						this.name_error = 'Please input your name'
						first_error = 'name'
					}
					this.feedback_form.question_list.forEach((item,index)=>{
						if(item.is_required){
							if(item.answer_type == 'TEXT' && item.answer == ''){
								item.error = 'Please enter the answer to this question'
								first_error = first_error == '' ? item.id : first_error 
							}else if(item.answer_type == 'STAR' && item.answer <= 0){
								item.error = 'Please give a star to this question'
								first_error = first_error == '' ? item.id : first_error 
							}else if(item.answer_type == 'CHOICE' && !item.answer.id){
								item.error = 'Please choose one answer to this question'
								first_error = first_error == '' ? item.id : first_error 
							}else if(item.answer_type == 'MULTIPLE_CHOICE' && item.answer.length == 0){
								item.error = 'Please choose at least one answer to this question'
								first_error = first_error == '' ? item.id : first_error 
							}else{
								item.error = ''
							}
						}

						if(index+1 == this.feedback_form.question_list.length){
							if(first_error != ''){
								fail(first_error)
							}else{
								success()
							}
						}
					})
				})
			},
			submitForm(){
				return new Promise((success,fail)=>{
					this.validateForm().then(res=>{
						let params = {
							user_detail: !this.reservation.id ? {name:this.guest_name} : null,
							reservation_id: this.params.reservation_id,
							question_answer: []
						}
						this.feedback_form.question_list.forEach(item=>{
							let return_data = {
								question: item.id,
								answer: item.answer
							}
							if(item.answer_type == 'CHOICE'){
								return_data.answer = item.answer.id
							}else if(item.answer_type == 'MULTIPLE_CHOICE'){
								return_data.answer = item.answer.map(x=>x.id)
							}

							params.question_answer.push(return_data)
						})
						post("CORE_HOTEL",`feedback-form/${this.params.feedback_id}/answer?merchant_id=${this.getMerchant.id}`,params).then(response=>{
							let res = response.data
							if(res.success){
								this.toggleResult('success')
								success()
							}else{
								this.toggleResult('fail')
								fail(res.message)
							}
						})
						success()
					}).catch(err=>{
						console.log(err)
						this.$smoothScroll(err)
						fail()
					})
				})
			}
		}
	}
</script>
<style type="text/css" scoped>
	.close-p{
		margin: 10px 23px;
    background-color: rgba(0, 0, 0, 0.41);
    z-index: 9;
    right: 0;
    top: 100px;
	}
	.img-p-c{
		position: relative;
		top: 200px;
	}
	input[type=checkbox] {
	   position: relative;
	   cursor: pointer;
	   margin-right: 4px;
  }
  input[type=checkbox]:before {
	 content: "";
	 display: block;
	 position: absolute;
	 width: 16px;
	 height: 16px;
	 border-radius: 3px;
	 top: 0;
	 left: 0;
	 background-color:#fff;
	 border: 1px solid #999;
	}
	input.checkbox[type=checkbox]:checked:before {
	 content: "";
	 display: block;
	 position: absolute;
	 width: 16px;
	 height: 16px;
	 border-radius: 3px;
	 top: 0;
	 left: 0;
	 background-color:var(--merchant-primary-color);
	}
	input[type=checkbox]:checked:after {
	 content: "";
	 display: block;
	 width: 5px;
	 height: 10px;
	 border: solid white;
	 border-width: 0 2px 2px 0;
	 -webkit-transform: rotate(45deg);
	 -ms-transform: rotate(45deg);
	 transform: rotate(45deg);
	 position: absolute;
	 top: 2px;
	 left: 6px;
	}


/*RADIO BUTTON*/
	input[type=radio] {
	   position: relative;
	   cursor: pointer;
	   margin-right: 4px;
  }
  input[type=radio]:before {
	 content: "";
	 display: block;
	 position: absolute;
	 width: 18px;
	 height: 18px;
	 border-radius: 100%;
	 top: 0;
	 left: 0;
	 background-color:#fff;
	 border: 1px solid #999;
	}
	input.radio[type=radio]:checked:before {
	 content: "";
	 display: block;
	 position: absolute;
	 width: 18px;
	 height: 18px;
	 border-radius: 100%;
	 top: 0;
	 left: 0;
	 border: 2px solid var(--merchant-primary-color);
	}
	input[type=radio]:checked:after {
		content: "";
	  display: block;
	  width: 13px;
	  height: 13px;
	  border-radius: 100%;
	  border: 2px solid white;
		background-color:var(--merchant-primary-color);
	  position: relative;
	  top: 3px;
	  left: 3px;
	}
	
	.th-feedback{
		border-top: 1px solid #ddd;
    border-radius: 20px 20px 0 0;
    background-color: #fff;
    margin-top: -24px;
	}
	.vue-star-rating{
		display: inline-block;
	}
</style>


// WEBPACK FOOTER //
// src/pages/general/feedback-v2/GuestForm.vue